import React from "react";

export const LoadingSpinner = (props: React.SVGAttributes<SVGSVGElement>) => {
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 100);
  }, []);

  const opacityVals = [
    "0.619598",
    "0.562811",
    "0.519598",
    "0.419598",
    "0.319598",
    "0.219598",
    "0.119598",
    "0.0195984",
  ];

  const opacitys = {
    a: opacityVals[index % 8],
    b: opacityVals[(index + 1) % 8],
    c: opacityVals[(index + 2) % 8],
    d: opacityVals[(index + 3) % 8],
    e: opacityVals[(index + 4) % 8],
    f: opacityVals[(index + 5) % 8],
    g: opacityVals[(index + 6) % 8],
    h: opacityVals[(index + 7) % 8],
  };

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_230_10097"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <path d="M40 0H0V40H40V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_230_10097)">
        <g opacity={opacitys.d}>
          <path
            d="M9.33259 6.98942L13.8581 11.5149C14.4825 12.1393 14.4825 13.1532 13.8581 13.7776C13.2337 14.402 12.2197 14.402 11.5953 13.7776L7.06985 9.25216C6.44544 8.62776 6.44544 7.61382 7.06985 6.98942C7.69425 6.36501 8.70819 6.36501 9.33259 6.98942Z"
            fill="currentColor"
          />
        </g>
        <g opacity={opacitys.e}>
          <path
            d="M3.21914 18.152H9.61914C10.5022 18.152 11.2191 18.869 11.2191 19.752C11.2191 20.635 10.5022 21.352 9.61914 21.352H3.21914C2.3361 21.352 1.61914 20.635 1.61914 19.752C1.61914 18.869 2.3361 18.152 3.21914 18.152Z"
            fill="currentColor"
          />
        </g>
        <g opacity={opacitys.f}>
          <path
            d="M6.78953 30.3681L11.315 25.8426C11.9394 25.2182 12.9533 25.2182 13.5778 25.8426C14.2022 26.467 14.2022 27.4809 13.5778 28.1053L9.05227 32.6308C8.42787 33.2552 7.41393 33.2552 6.78953 32.6308C6.16512 32.0064 6.16512 30.9925 6.78953 30.3681Z"
            fill="currentColor"
          />
        </g>
        <g opacity={opacitys.g}>
          <path
            d="M17.9523 36.4816V30.0816C17.9523 29.1986 18.6693 28.4816 19.5523 28.4816C20.4354 28.4816 21.1523 29.1986 21.1523 30.0816V36.4816C21.1523 37.3646 20.4354 38.0816 19.5523 38.0816C18.6693 38.0816 17.9523 37.3646 17.9523 36.4816Z"
            fill="currentColor"
          />
        </g>
        <g opacity={opacitys.h}>
          <path
            d="M30.1684 32.9114L25.6429 28.3859C25.0185 27.7615 25.0185 26.7476 25.6429 26.1232C26.2673 25.4988 27.2812 25.4988 27.9056 26.1232L32.4311 30.6486C33.0555 31.273 33.0555 32.287 32.4311 32.9114C31.8067 33.5358 30.7928 33.5358 30.1684 32.9114Z"
            fill="currentColor"
          />
        </g>
        <g opacity={opacitys.b}>
          <path
            d="M36.2818 21.7488H29.8818C28.9988 21.7488 28.2818 21.0318 28.2818 20.1488C28.2818 19.2658 28.9988 18.5488 29.8818 18.5488H36.2818C37.1649 18.5488 37.8818 19.2658 37.8818 20.1488C37.8818 21.0318 37.1649 21.7488 36.2818 21.7488Z"
            fill="currentColor"
          />
        </g>
        <g opacity={opacitys.a}>
          <path
            d="M32.7114 9.53273L28.186 14.0582C27.5616 14.6826 26.5476 14.6826 25.9232 14.0582C25.2988 13.4338 25.2988 12.4199 25.9232 11.7955L30.4487 7.26999C31.0731 6.64559 32.087 6.64559 32.7114 7.26999C33.3359 7.8944 33.3359 8.90833 32.7114 9.53273Z"
            fill="currentColor"
          />
        </g>
        <g opacity={opacitys.c}>
          <path
            d="M21.5486 3.4192V9.8192C21.5486 10.7022 20.8317 11.4192 19.9486 11.4192C19.0656 11.4192 18.3486 10.7022 18.3486 9.8192V3.4192C18.3486 2.53616 19.0656 1.8192 19.9486 1.8192C20.8317 1.8192 21.5486 2.53616 21.5486 3.4192Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};
